import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';
import { GaService } from 'src/app/core/helpers/ga.service';
import { LoaderService } from 'src/app/core/helpers/loader.service';

@Component({
    selector: 'loyaltic-participate-with-phone',
    templateUrl: './participate-with-phone.component.html',
    styleUrls: ['./participate-with-phone.component.scss'],
    standalone: false
})
export class ParticipateWithPhoneComponent implements OnInit {

  receipt: any;
  Quantity = 1;
  ReceiptName = '';
  UserName = '';
  IsAcceptTerms = false;
  IsPrivacyPolicy = false;
  IsUserAlreadyLoggedIn = false;
  receiptSrc: any;
  receiptNotApprovedData: any;
  userId = ''
  LoginType = 'Phone';
  Phone = '';
  culture = '';
  clicked = false;

  @Output() receiptUploadSuccess = new EventEmitter<any>();

  constructor(private authService: AuthService, private coreService: CoreService,
    private toast: ToastrService, private translate: TranslateService, private loaderService: LoaderService,
    private router: Router,
    private gaService: GaService,
    private modalService: BsModalService) {
      this.culture = translate.getDefaultLang();
     }


  ngOnInit() {
    this.resetToken();
    this.userId = this.authService.getUserId();
    if (this.userId) {
      this.IsUserAlreadyLoggedIn = true;
      this.coreService.getEmailAndPhone(this.userId).then((response:any) =>{
        console.log('userr', response);
        // this.Email = response.result.userName;
        this.Phone = response.result.userName;
      })

    }

  }

  freshParticipation() {
    this.authService.resetTokens();
    this.router.navigate([this.router.url])
 }

  resetToken() {
    const tokenTime = this.authService.getTokenTime();
    if (tokenTime) {
      const differenceMs = +new Date().getTime() - +new Date(tokenTime).getTime();
      const sec = differenceMs / 1000;
      const hours = sec / 3600;
      if (hours > 24) { this.authService.resetTokens() }
    }
  }

  onReceiptSelect(event) {
    this.receipt = event.target.files[0];
    this.ReceiptName = this.receipt.name;
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (e: any) => {
        const img = document.createElement('img');
        img.src = e.target.result;
        this.receiptSrc = e.target.result;
      };
    }
  }

  showAnimationPopup() {
    // this.modalRef = this.modalService.show(this.uploadAnimationRef, this.popupConfig);
  }

  onReceiptUpload(form) {
    // const userId = this.authService.getUserId();
    const formData = new FormData();
    this.Quantity = this.receipt ? 1 : 0
    // this.LoginType =
    localStorage.setItem('LoginType',this.LoginType)

      formData.append('LoginType', this.LoginType.toString())
      formData.append('Quantity', this.Quantity.toString());
      formData.append('File', this.receipt);
      formData.append('Value', this.Phone);
      formData.append('HasOptedForMarkettingEmail', this.IsPrivacyPolicy ? 'true' : 'false');
      formData.append('Culture', this.translate.getDefaultLang());
      this.coreService.participate(formData).then((response: any) => {
      this.clicked = true;

      // localStorage.setItem('phoneUser', this.Phone)
      // localStorage.getItem('surveyTaken')? localStorage.removeItem('surveyTaken'):''
        // this.modalRef.hide();
        if (response.result.isNewUser){
          // this.gaService.emitEvent('new_user', 'new_user');
          sessionStorage.setItem('session','true')
        } else if(sessionStorage.getItem('session') != 'true') {
          // this.gaService.emitEvent('returning_user', 'returning_user');
        }

        if (!response.result.isapproved && response.result.recptPartitionKey && response.result.recptRowKey) {
          this.receiptNotApprovedData = response.result;
          return;
        }

        form.submitted = false;
        this.resetForm();
        const result = response.result;
        this.authService.setToken(result.token, result.id);
        localStorage.setItem('isWithFlow', '1');
        localStorage.setItem('playType', '0');
        response.result.isIntermediatePlayPageEnabled ? this.router.navigate(['click-to-play']): this.router.navigate(['play']);
      }).catch((errorResponse: any) => {
        this.clicked = false;
        console.log('error', errorResponse);
      });
  }

  resetForm() {
    this.receipt = undefined;
    this.UserName = undefined;
    this.ReceiptName = undefined;
    this.IsAcceptTerms = false;
    this.IsPrivacyPolicy = false;
  }
}
